import { Award } from 'lucide-react';
import { Certificate } from '../types';

// Helper function to safely parse dates
const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return 'N/A';
    
    try {
        // Handle different date formats
        let date: Date;
        if (dateString.includes('T')) {
            // Already has time component
            date = new Date(dateString);
        } else {
            // Date only, add time component
            date = new Date(dateString + 'T00:00:00');
        }
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
            console.warn('Invalid date:', dateString);
            return 'Invalid date';
        }
        
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
    } catch (error) {
        console.error('Error parsing date:', dateString, error);
        return 'Invalid date';
    }
};

interface CertificateItemProps {
    certificate: Certificate;
    onViewCertificate: (certificate: Certificate) => void;
}

// You can choose either named export (Option 1) or default export (Option 2)

// Option 1: Named export (current)
export function CertificateItem({ certificate, onViewCertificate }: CertificateItemProps) {
    return (
        <li className="p-4 flex flex-wrap items-center justify-between hover:bg-slate-50 gap-4">
            <div className="flex items-center flex-grow min-w-0">
                <Award size={24} className="text-primary-500 mr-4 flex-shrink-0"/>
                <div className="min-w-0">
                    <p className="font-medium text-slate-800 truncate">{certificate.title}</p>
                    <p className="text-sm text-slate-500">Completed: {formatDate(certificate.issued_at)}</p>
                </div>
            </div>
            <div className="space-x-2 flex-shrink-0">
                <button
                    onClick={() => onViewCertificate(certificate)}
                    className="px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-md hover:bg-primary-200"
                >
                    Download
                </button>
            </div>
        </li>
    );
}
